import { httpClient } from '@/core/services/http'
import { cache } from 'react'
import { createGetAirportsUseCase } from '../use-cases/get-airports.usecase'
import { createGetCitiesUseCase } from '../use-cases/get-cities.usecase'
import { createGetCountriesUseCase } from '../use-cases/get-countries.usecase'
import { createGetLocationInfoUseCase } from '../use-cases/get-location-info.usecase'
import { createSearchLocationUseCase } from '../use-cases/search-location.usecase'

export const getCountries = cache(
  createGetCountriesUseCase({
    httpClient,
  }),
)
export const getCities = cache(
  createGetCitiesUseCase({
    httpClient,
  }),
)

export const getAirports = cache(
  createGetAirportsUseCase({
    httpClient,
  }),
)

export const getLocationInfo = createGetLocationInfoUseCase({
  httpClient,
})

export const searchLocation = createSearchLocationUseCase({
  httpClient,
})
